module.exports = __webpack_public_path__ + "img/s303.f71bb15b.jpg";